module.exports = __webpack_public_path__ + "fonts/Roboto-Regular-768b7011.woff";